import { TPackageSizesResponse } from "../models/packageSizes";
import { TPackageSize } from "../types";

const mapPackageSizesResponse = (response: TPackageSizesResponse): TPackageSize[] =>
  (response || []).map((packageSize) => ({
    id: packageSize.id,
    title: packageSize.title,
    image: packageSize.image || null,
    hoverImage: packageSize.hoverImage || null,
    weight: packageSize.weight || "",
    description: packageSize.description || "",
  }));
export default mapPackageSizesResponse;
